import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { devTools } from '@ngneat/elf-devtools';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const initSentry = () => {
  Sentry.init({
    dsn: 'https://3bc92a668b70504bcc51ea08381ed45c@o4507446340747264.ingest.de.sentry.io/4508578824781904',
  });
  Sentry.setTag('build_changeset', environment.build.changeset);
  Sentry.setTag(
    'version',
    `${environment.version.major}.${environment.version.minor}.${environment.version.patch}`,
  );
};

if (environment.production) {
  enableProdMode();
  initSentry();
} else {
  devTools();
}

bootstrapApplication(AppComponent, appConfig).catch(error =>
  console.error(error),
);
